
import status from './status.json' 

export function getDateFormatted(date_o){
        let date = new Date(Date.parse(date_o))
        return date.getDate() + "/" + (Number(date.getMonth()) + 1) + "/" + date.getFullYear()
    }   

export function getStatusValue(order_status,lang){
    let lng = status.find(x=>x.lang === lang).status
    let stato = lng.find(x=>x.key === order_status)
    if (stato){
        return stato.value
    }
    return order_status
}
export function getAllStatus(lang){
    let lng = status.find(x=>x.lang === lang).status
    let result=[]
    lng.forEach(element => {
        result.push(element)
    });
    return result
}
export function getAllStatusAviable(lang,order){
    let lng = status.find(x=>x.lang === lang).status
    let result=[]
    lng.forEach(element => {
        switch (element.key) {
            case "created":
                if(order.created_timestamp === null){
                    result.push(element)
                }
                break;
            case "under_processing":
                if(order.under_processing_timestamp === null){
                    result.push(element)
                }
                break;
            case "shipped":
                if(order.shipping_timestamp === null){
                    result.push(element)
                }
                break;
            case "paid":
                if(order.payment_timestamp === null){
                    result.push(element)
                }
                break;
            case "refunded":
                if(order.refunded_timestamp === null){
                    result.push(element)
                }
                break;
            case "completed":
                if(order.completed_timestamp === null){
                    result.push(element)
                }
                break;
            case "submitted_for_settlement":
                if(order.on_settlement_timestamp === null){
                    result.push(element)
                }
                break;
            default:
                break;
        }
    });
    return result
}

export function  getStatusMessageValue(order_status,lang){
    let lng = status.find(x=>x.lang === lang).status
    let stato = lng.find(x=>x.key === order_status)
    if (stato){
        return stato.msg
    }
    return ""
}

  

